export default __webpack_public_path__ + "static/media/08OlaOuKale60s.b739f0cf.mp3";